import { render, staticRenderFns } from "./TenderListItem.vue?vue&type=template&id=2f99eb04"
import script from "./TenderListItem.vue?vue&type=script&lang=js"
export * from "./TenderListItem.vue?vue&type=script&lang=js"
import style0 from "./TenderListItem.vue?vue&type=style&index=0&id=2f99eb04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports